import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Flex, Typography } from "antd";
import { ContractsList } from "entities/contracts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";

export const ContractsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Flex vertical gap="middle">
      <Typography.Title level={3}>
        <Button
          type="link"
          size="large"
          icon={
            <ArrowLeftOutlined style={{ fontSize: "20px", marginRight: 8 }} />
          }
          onClick={() => navigate(ROUTES.MAIN)}
        ></Button>
        {t("contracts.title")}
      </Typography.Title>
      <ContractsList />
    </Flex>
  );
};
